import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { CURRENT_INSTANCE } from '../tenant';

const ns = CURRENT_INSTANCE.i18nNamespace;

export const DEFAULT_LANGUAGE = 'de';

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [DEFAULT_LANGUAGE],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: true,
    },
    ns: [ns],
    defaultNS: ns,
  });

export default i18n;
